module.exports = __webpack_public_path__ + "static/img/gift_zh.8460a50a.png";